export const DEPARTMENT_COLORS = {
    IT: "#1f77b4",                     // Blue
    Mech: "#ff7f0e",                   // Orange
    Automation: "#2ca02c",            // Green
    "Multimedia / UIUX": "#d62728",     // Red
    "Embedded/PCB/IOT": "#9467bd",    // Purple
    Aerospace: "#8c564b",             // Brown
    Matlab: "#e377c2",                // Pink
    "Automotive embedded & EV design": "#7f7f7f", // Grey
    VLSI: "#bcbd22",                  // Olive
    "Digital Marketing": "#17becf",   // Cyan
    Civil: "#4b0082",                 // Indigo
    "Piping Design": "#ff1493",       // Deep Pink
    MEP: "#00fa9a",                   // Mint Green
    SAP: "#ffa500"                    // Orange Yellow
};

// fallback color
export const DEFAULT_COLOR = "#999";